import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Dialog from "@material-ui/core/Dialog";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";
import Slide from "@material-ui/core/Slide";
import CameraEventRepository from "../../../repositories/CameraEventRepository";
import {
  Card,
  CardActionArea,
  CardMedia,
  Container,
  Grid,
} from "@material-ui/core";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import List from "@material-ui/core/List";
import { FullImagePreview } from "../../../components/FullImagePreview";
import CardContent from "@material-ui/core/CardContent";
import StaticClassifierRepository from "../../../repositories/StaticClassifierRepository";

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: "relative",
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  cardContainer: {
    paddingTop: "16px",
  },
  cardItem: {
    float: "left",
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const AdjacentEventsView = ({ id, onClose }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [currentEvent, setCurrentEvent] = useState(null);
  const [events, setEvents] = useState([]);
  const [imagePreview, setImagePreview] = useState(null);
  const repository = new CameraEventRepository();
  const classifierRepository = new StaticClassifierRepository();

  useEffect(async () => {
    try {
      const event = await repository.getById(id);

      const rs = await repository.getAdjacentEventsById(id);
      setEvents(rs.data.Events);
      setCurrentEvent(event.data);
    } catch (e) {
      handleClose();
    }
  }, [id]);

  const handleClose = () => {
    onClose({});
  };

  return (
    <>
      {imagePreview && (
        <FullImagePreview
          src={imagePreview}
          onClick={(e) => setImagePreview(null)}
        />
      )}
      <Dialog
        fullWidth={true}
        maxWidth={"lg"}
        open={true}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography variant="h6" className={classes.title}>
              {t("Adjacent event")} - {currentEvent && currentEvent.NumberPlate}
            </Typography>
          </Toolbar>
        </AppBar>
        <Container className={classes.cardContainer}>
          {events &&
            events.map((item, i) => (
              <Card key={i} style={{ width: 250 }} className={classes.cardItem}>
                <CardActionArea>
                  <CardMedia
                    onClick={(e) => setImagePreview(item.EventImageUrl)}
                    component="img"
                    height="140"
                    image={item.EventImageUrl}
                    alt="green iguana"
                  />
                  <CardContent>
                    <List className="condensedList">
                      <ListItem>
                        <ListItemText primary={t("Id")} secondary={item.Id} />
                      </ListItem>
                      <ListItem>
                        <ListItemText
                          primary={t("Event date")}
                          secondary={item.EventDate}
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText
                          primary={t("Camera")}
                          secondary={item.CameraCode}
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText
                          primary={t("Direction")}
                          secondary={item.Direction}
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText
                          primary={t("Suspicious")}
                          secondary={
                            item.Suspicious
                              ? classifierRepository.getCameraEventSuspiciousStatusNameById(
                                  item.Suspicious
                                )
                              : "-"
                          }
                        />
                      </ListItem>
                    </List>
                  </CardContent>
                </CardActionArea>
              </Card>
            ))}
        </Container>
      </Dialog>
    </>
  );
};

export default AdjacentEventsView;
